<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconSort_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M7.833 6.352 4.843 3.39a.6.6 0 0 0-.845 0l-2.99 2.962a.59.59 0 0 0 0 .837.6.6 0 0 0 .846 0l1.992-1.973v6.967c0 .332.272.6.606.6a.603.603 0 0 0 .606-.6V5.278l1.93 1.911a.6.6 0 0 0 .845 0 .59.59 0 0 0 0-.837M7.834 9.648l2.989 2.962a.6.6 0 0 0 .845 0l2.99-2.962a.59.59 0 0 0 0-.837.6.6 0 0 0-.845 0l-1.993 1.973V3.817c0-.331-.27-.6-.606-.6a.603.603 0 0 0-.605.6v6.905l-1.93-1.911a.6.6 0 0 0-.845 0 .59.59 0 0 0 0 .837"
    />
</svg>
